export const getCookie = (name) => {
	const value = '; ' + document.cookie;
	const parts = value.split('; ' + name + '=');
	if(parts.length === 2) return parts.pop().split(';').shift();
	return null;
};

export const setCookie = (name, value) => {
	const days = 30;
	const date = new Date();
	// Expiration set to one year
	date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000 * 365));
	const expires = '; expires=' + date.toUTCString();
	document.cookie = name + '=' + (value || '') + expires + '; path=/';
};

export const removeCookie = (sKey, sPath, sDomain) => {
	document.cookie = encodeURIComponent(sKey)
		+ '=; expires=Thu, 01 Jan 1970 00:00:00 GMT'
		+ (sDomain ? '; domain=' + sDomain : '')
		+ (sPath ? '; path=' + sPath : '');
};
